import { Component } from '@angular/core';

@Component({
  selector: 'app-post-audio-icon',
  templateUrl: './post-audio-icon.component.html',
  standalone: true,
  styleUrls: ['./post-audio-icon.component.scss']
})
export class PostAudioIconComponent {
}

